import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChakraPageTitle } from 'app/components/Core';
import { Notifications as NotificationsList } from 'app/components/Notifications';
import { InviteTransferDialog } from 'app/components/Notifications/InviteTransferDialog';
import { useAppSelector } from 'app/store';
import { getDisplayName } from 'app/store/Auth/selectors';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';
import { ContentContainerType } from 'types/enums';
import { useChatFeatureFlag } from 'featureFlags';
import { routes } from 'app/routing/routesConfig';
import { NavTabs } from 'app/components/Core/ChakraNavTabs';
import { getNewNotificationsCounts } from 'app/store/Notifications/selectors';

export const Notifications: React.FC = () => {
  const { chatFeatureEnabled } = useChatFeatureFlag();
  const displayName = useAppSelector(getDisplayName);
  const location = useLocation();
  const notificationsCounts = useAppSelector(getNewNotificationsCounts);

  if (chatFeatureEnabled) {
    return (
      <ContentContainer type={ContentContainerType.LIST} pt={6} pb={24}>
        <ChakraPageTitle pb={6}>Activity</ChakraPageTitle>
        <NavTabs
          variant="soft-rounded"
          routes={[routes.notifications, routes.messages]}
          counts={{
            [routes.notifications.name]: notificationsCounts.activityCount,
            [routes.messages.name]: notificationsCounts.unreadChatMessagesCount,
          }}
        />
        <NotificationsList />
        <InviteTransferDialog location={location} displayName={displayName} />
      </ContentContainer>
    );
  }

  return (
    <ContentContainer type={ContentContainerType.LIST} pt={6} pb={24}>
      <ChakraPageTitle>Notifications</ChakraPageTitle>
      <NotificationsList />
      <InviteTransferDialog location={location} displayName={displayName} />
    </ContentContainer>
  );
};
